<template>
  <div class="business-detail-page">
    <headerView :seletedindex="seletedindex" />
    <!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(' +
          contactUsBanner.imgUrl +
          ')',
      }"
    >
      <div class="banner-content">
        <h1>{{ contactUsBanner.title }}</h1>
        <p>{{ contactUsBanner.subTitle }}</p>
      </div>
    </div>

    <!-- 业务详情内容 -->
    <div class="business-detail-section">
      <div class="business-detail-container">
        <!-- 业务板块名称 -->
        <h2 class="business-detail-title">{{ businessDetail.title }}</h2>
        
        <!-- 富文本内容 -->
        <div class="business-detail-content" v-html="businessDetail.content"></div>
      </div>
    </div>

    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner,businessSegmentDetails } from "@/api/index";

export default {
  name: "BusinessDetail",
  components: {
    headerView,
    footerView,
  },
  data() {
    return {
      seletedindex: 7,
      contactUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      businessModules: [
        {
          title: "智慧课堂",
          description:
            "集成AI技术与教育理念,打造互动式学习环境,提升教学效果与学习体验",
          image: require("@/assets/images/educationalServices1.png"),
          content: `<p>智慧课堂是我们基于AI技术和先进教育理念打造的核心教育产品。通过智能化的教学工具和互动式学习环境，我们致力于提升教学效果与学习体验。</p>
            <h3>核心特点：</h3>
            <ul>
              <li>AI智能辅助教学系统，个性化学习路径推荐</li>
              <li>互动式多媒体教学工具，增强课堂参与度</li>
              <li>实时学习数据分析，精准掌握学生学习状态</li>
              <li>云端资源库，丰富的教学素材和课程内容</li>
            </ul>
            <h3>应用场景：</h3>
            <p>适用于K12教育的各个阶段，支持在线和线下混合教学模式，为教师和学生提供全方位的智能教学解决方案。</p>`,
        },
        {
          title: "素质教育",
          description:
            "全面发展学生综合素质,包括艺术、体育、科技创新等多元培养体系",
          image: require("@/assets/images/educationalServices2.png"),
          content: `<p>素质教育是我们多元化教育体系的重要组成部分，旨在全面发展学生的综合素质，培养具有创新精神和实践能力的未来人才。</p>
            <h3>培养方向：</h3>
            <ul>
              <li>艺术素养：音乐、美术、舞蹈等艺术类课程</li>
              <li>体育健康：各类体育运动和健康生活方式培养</li>
              <li>科技创新：STEM教育、编程、机器人等科技课程</li>
              <li>社会实践：社区服务、公益活动等实践体验</li>
            </ul>
            <h3>课程特色：</h3>
            <p>采用项目式学习方式，通过实际项目和实践活动，让学生在体验中学习，在实践中成长，全面提升综合素质和能力。</p>`,
        },
        {
          title: "国际教育",
          description:
            "引进国际先进教育理念与课程体系,培养具有全球视野的未来人才",
          image: require("@/assets/images/educationalServices3.png"),
          content: `<p>国际教育致力于引进国际先进教育理念与课程体系，为学生提供国际化教育平台，培养具有全球视野的复合型人才。</p>
            <h3>课程体系：</h3>
            <ul>
              <li>IB国际文凭课程</li>
              <li>AP美国大学先修课程</li>
              <li>A-Level英国高中课程</li>
              <li>国际化双语教学</li>
            </ul>
            <h3>服务内容：</h3>
            <p>提供完整的国际教育规划、海外升学指导、语言培训、文化交流等服务，帮助学生顺利适应国际化学习环境，实现海外求学梦想。</p>`,
        },
        {
          title: "教育科技",
          description:
            "研发教育科技产品,利用大数据、AI等技术,提供智能学习解决方案",
          image: require("@/assets/images/educationalServices1.png"),
          content: `<p>教育科技是我们持续投入研发的重点领域，通过大数据、AI、云计算等前沿技术，为教育行业提供创新的智能学习解决方案。</p>
            <h3>技术优势：</h3>
            <ul>
              <li>大数据分析：学习行为分析和个性化推荐</li>
              <li>人工智能：智能答疑、作业批改、学习路径规划</li>
              <li>云计算平台：稳定可靠的在线教育基础设施</li>
              <li>移动学习：随时随地学习，打破时空限制</li>
            </ul>
            <h3>产品矩阵：</h3>
            <p>涵盖在线学习平台、智能教学系统、学习评测工具、教育管理平台等多个产品线，为教育机构、教师和学生提供全方位的技术支持。</p>`,
        },
        {
          title: "教师培训",
          description:
            "为教育工作者提供专业发展支持,提升教学技能与教育理念",
          image: require("@/assets/images/educationalServices2.png"),
          content: `<p>教师培训是我们为教育工作者提供的专业发展支持服务，致力于提升教师的教学技能与教育理念，推动教育质量的持续提升。</p>
            <h3>培训内容：</h3>
            <ul>
              <li>教学方法培训：最新的教学理念和方法论</li>
              <li>技术应用培训：教育科技工具的使用和整合</li>
              <li>课程设计培训：课程开发和教学设计能力</li>
              <li>学生管理培训：班级管理和学生发展指导</li>
            </ul>
            <h3>培训形式：</h3>
            <p>采用线上+线下结合的培训模式，提供系统化的培训课程、工作坊、研讨会等多种形式，满足不同层次教师的发展需求。</p>`,
        },
      ],
      businessDetail: {
        title: "",
        content: "",
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.getcontactUsBanner();
      this.getBusinessDetail();
    });
  },
  methods: {
    async getcontactUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 25 });
      if (res && res.length > 0) {
        this.contactUsBanner = res[0];
      }
    },
    async getBusinessDetail() {
      // 从路由参数获取业务板块索引
      const index = parseInt(this.$route.params.index);
      const res = await businessSegmentDetails("/api/zaoying/business/detail", { id: index });
      console.log(res)
      if (res) {
        this.businessDetail = {
          title: res.title,
          content: res.content || "<p>暂无详细内容</p>",
        };
      }else {
        // 如果找不到对应的业务板块，显示默认内容
        this.businessDetail = {
          title: "业务板块",
          content: "<p>暂无详细信息</p>",
        };
      }
    },
  },
};
</script>

<style scoped>
.business-detail-page {
  min-height: 100vh;
  background-color: #fff;
}

.banner {
  background-size: cover;
  background-position: center;
  height: 25vw;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px;
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

/* 业务详情样式 */
.business-detail-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.business-detail-container {
  background-color: #fff;
}

.business-detail-title {
  font-size: 36px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.business-detail-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  padding: 40px;
  background-color: #fafafa;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.business-detail-content ::v-deep p {
  margin-bottom: 20px;
  text-align: justify;
  color: #555;
}

.business-detail-content ::v-deep h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-top: 30px;
  margin-bottom: 15px;
}

.business-detail-content ::v-deep ul {
  margin-bottom: 20px;
  padding-left: 30px;
}

.business-detail-content ::v-deep li {
  margin-bottom: 10px;
  line-height: 1.8;
  color: #555;
}

.business-detail-content ::v-deep img {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .business-detail-section {
    padding: 60px 20px;
  }

  .business-detail-title {
    font-size: 28px;
  }

  .business-detail-content {
    font-size: 14px;
    padding: 20px;
  }

  .business-detail-content ::v-deep h3 {
    font-size: 20px;
  }
}
</style>

